<template>
	<div
	class="nav-current-acounts p-15"
	inline>
		<label>Mostrar los ultimos</label>
		<b-form-input
		v-model="cantidad_movimientos"
		@keydown.enter="getCurrentAcounts"
		class="input"
		min="1"
		type="number"></b-form-input>
		<label>movimientos</label>
		<b-button
		@click="getCurrentAcounts"
		variant="primary"
		class="m-l-15">
			Buscar
		</b-button>
    <div>
  <b-dropdown variant="danger" id="dropdown-1" text="Dropdown Button" class="m-l-15"><template #button-content>
  <i class="icon-print"></i></template>
    <b-dropdown-item @click="print('simple')">Imprimir</b-dropdown-item>
    <b-dropdown-item @click="print('details')">Imprimir Desglose</b-dropdown-item>
  </b-dropdown>
</div>
		<b-button
		v-if="from_model.current_acounts_count == 0"
		class="m-l-15"
		@click="saldoInicial"
		variant="primary">
			Saldo inicial
		</b-button>
		<btn-loader
		:block="false"
		:loader="checking"
		class="m-l-15"
		text="Chequear Saldos"
		@clicked="checkSaldos">
		</btn-loader>
	</div>
</template>
<script>
import current_acounts from '@/mixins/current_acounts'
export default {
	name: 'CurrentAcountsNav',
	mixins: [current_acounts],
	components: {
		BtnLoader: () => import('@/common-vue/components/BtnLoader'),
	},
	data() {
		return {
			checking: false
		}
	},
	computed: {
		cantidad_movimientos: {
			set(value) {
				this.$store.commit('current_acount/set_cantidad_movimientos', value)
			},
			get() {
				return this.$store.state.current_acount.cantidad_movimientos
			}
		},
		loading() {
			return this.$store.state.current_acount.loading
		},
        client() {
            return this.$store.state.current_acount.client
        },
        can_print() {
        	return this.selected_current_acounts.length == 0 || this.is_selected_printable
        },
        is_selected_printable() {
        	return this.selected_current_acounts.length == 1 && (this.selected_current_acounts[0].status == 'nota_credito' || this.selected_current_acounts[0].status == 'pago_from_client')
        }
	},
	methods: {
		checkSaldos() {
			this.checking = true
			this.$api.get('check-saldos/'+this.from_credit_account.id)
			.then(() => {
				this.checking = false
				this.$store.dispatch('current_acount/getModels')
			})
			.catch(err => {
				this.checking = false
			})
		},
        saldoInicial() {
            // this.$store.commit('clients/setSaldoInicial', this.client)
            this.$bvModal.show('saldo-inicial')
        },
		getCurrentAcounts() {
			this.$store.dispatch('current_acount/getModels')
		},
		print(detail) {
            let link = process.env.VUE_APP_API_URL+'/current-acount/pdf/'+this.from_credit_account.id+'/'+this.cantidad_movimientos+'/'+detail
            window.open(link)
		},
	}
}
</script>
<style scoped lang="sass">
.nav-current-acounts
	display: flex
	flex-direction: row
	justify-content: flex-start
	align-items: center
	.input
		width: 100px
		margin: 0 1em
</style>